import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { RouterMenu } from '@core/config/routing-menu';
import { SignedGuard } from '@core/guards/signed.guard';
import { AccountResolve } from '@core/services/account/account.resolver';

const routes: Routes = [
  { path: '', redirectTo: RouterMenu.PRIVATE_AREA, pathMatch: 'full' },
  {
    path: RouterMenu.LOGIN,
    loadChildren: () => import('src/app/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: RouterMenu.PRIVATE_AREA,
    loadChildren: () => import('src/app/home/home.module').then((m) => m.HomeModule),
    canActivateChild: [SignedGuard],
    resolve: {
      account: AccountResolve,
    },
  },
  { path: '**', redirectTo: RouterMenu.PRIVATE_AREA, pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    useHash: true
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
